import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Table } from 'antd'

import getBalanceDetails, {
  BalanceDetail,
} from 'core/application/adminDashboard/reimbursements/reimbursementsBalances/getBalanceDetails'

import { queryRequest } from 'common/RequestUtils'

import BalanceDetailsColums from './BananceDetailsColumns'

interface BalanceDetailsProps {
  companyUserId: string
  planPeriodId: string
}

const BalanceDetails: React.FC<BalanceDetailsProps> = ({ companyUserId, planPeriodId }) => {
  const { t: translate } = useTranslation()
  const [balanceDetails, setBalanceDetails] = useState<BalanceDetail[]>([])

  useEffect(() => {
    fetchData()
  }, [planPeriodId])

  const fetchData = async () => {
    const result = await queryRequest(() => getBalanceDetails(companyUserId, planPeriodId))
    setBalanceDetails(result)
  }

  return (
    balanceDetails && <Table dataSource={balanceDetails} columns={BalanceDetailsColums(translate)} pagination={false} />
  )
}

export default BalanceDetails
